import React, { ReactNode } from 'react';

import { tableWidth } from '../../../constants';

interface DataCardTableProps {
    children: ReactNode;
}

export const DataCardTable = ({
    children,
}: DataCardTableProps): JSX.Element => (
    <div className="flex justify-center mx-3 h-full">
        <table className="table-fixed" style={{ width: tableWidth }}>
            <tbody>{children}</tbody>
        </table>
    </div>
);
